export const enforcementRequestsRoutes = [
   {
      path: 'enforcement-requests',
      loadComponent: () => import('./enforcement-requests.component').then(c => c.EnforcementRequestsComponent)
   },
   {
      path: 'enforcement-requests/:id/form-committee',
      loadComponent: () => import('./enforcement-request-committee-form/enforcement-request-committee-form.component').then(c => c.EnforcementRequestCommitteeFormComponent)
   },
   {
      path: 'enforcement-requests/:id',
      loadComponent: () => import('./enforcement-request-details/enforcement-request-details.component').then(c => c.EnforcementRequestDetailsComponent)
   },
   {
      path: 'my-committees',
      loadComponent: () => import('./my-committees/my-committees.component').then(c => c.MyCommitteesComponent)
   },
   {
      path: 'my-committees/:id',
      loadComponent: () => import('./committee-details/my-committee-details.component').then(c => c.MyCommitteeDetailsComponent)
   },
];